import { APP_SUBSCRIPTIONS } from "@lib/config/mercureSubscriptions";
import { ToastProvider } from "@/components/ui/toast/ToastProvider";
import { AppMercureSubscriber } from "./providers/AppMercureSubscriber";
import { MercureProvider } from "./providers/MercureProvider";
import { ThemeProvider } from "./providers/ThemeProvider";

export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <MercureProvider>
      <AppMercureSubscriber subscriptions={APP_SUBSCRIPTIONS}>
        <ThemeProvider>
          {children}
          <ToastProvider />
        </ThemeProvider>
      </AppMercureSubscriber>
    </MercureProvider>
  );
}
